import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import { clone } from 'ramda'

const state = {
  videos: []
}

const getters = {
  getVideos: state => state.videos,
  getVideoById: state => id => state.videos.find(video => video.id === id)
}

const actions = {
  async createVideo ({ commit }, video) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.video.req(), video)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Video was created')
      await this.dispatch('fetchVideos')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Create video')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVideos ({ commit }, { page = 0, itemsOnPage = 99999 } = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.video.req(), {params: {page, itemsOnPage}})
      commit(types.SET_VIDEOS_LIST, data.videos)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Load videos')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateVideo ({ commit }, video) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.video.req(), video)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Video was updated')
      await this.dispatch('fetchVideos')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Update video')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteVideo ({ commit }, videoId) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.video.delete(videoId))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Video was deleted')
      await this.dispatch('fetchVideos')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Delete video')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async saveVideosDisplaySettings ({ commit }, settings) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const payload = {
        metadata: clone(settings)
      }
      await this.$axios.put(api.videosDisplay.update(), payload)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'FAILED: Save videos display settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_VIDEOS_LIST] (state, videos) {
    state.videos = [...videos]
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/videos.js